import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import AiPrompt from "../domain/AiPrompt";
import {ResourceOwnerType} from "../domain/ResourceOwnerType";

export interface AiPromptRequest {
    name: string;
    description?: string;
    prompt: string;
    owner: ResourceOwnerType;
    organization?: string;
}

class AiPromptService {

    readonly basePath = "/ai-prompts";

    public add(aiPrompt: AiPromptRequest): Promise<string> {
        return Axios.post(`${this.basePath}`, aiPrompt).then(value => value.data.id);
    }

    public update(id: string, aiPrompt: AiPromptRequest): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, aiPrompt);
    }

    public get(id: string): Promise<AiPrompt> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => AiPrompt.fromPOJO(value.data));
    }

    public delete(aiPrompt: AiPrompt): Promise<void> {
        return Axios.delete(`${this.basePath}/${aiPrompt.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<AiPrompt>> {
        const query = queryOptions.toQueryParams();
        const url = `${this.basePath}?${query}`;

        return Axios.get(url)
            .then(value => {
                const list = value.data.data.map((objectJson: object) => AiPrompt.fromPOJO(objectJson));
                return new PagedResult(value.data.total, list);
            });
    }
}

export default AiPromptService;
